module.exports = __webpack_public_path__ + "static/img/policeLogo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/policeLogo.png
// module id = iMNn
// module chunks = 1